import React, { useState } from "react";
import { Modal, Button, InputGroup, Form } from "react-bootstrap"; // Import Modal and Button from react-bootstrap
import "./commonCard.css";
import formatDate from "../../utils/helpers/formatDate";
import { postDetails } from "../../services/http/http.service";
import APIList from "../../utils/constants/APIList";
import pdfforCards from '../../assets/temp/pdfforCards.svg';
import profileIcon from '../../assets/default-profile.png';
interface CardComponentProps {
  image_name: string;
  document_name:string;
  title?: string;
  count?: number;
  createdDate: string;
  onEditClick: () => void;
  isEditing: boolean;
  onImageChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onUpdateClick?: () => void;
  update?: boolean;
  onTitleChange?: (newTitle: string) => void;
  id?: number;
  FolderImage: string;
  documentName?: string;
  content?: string;
  myconnect_master_id?: number;
  isFolder?: boolean;
  onDeleteClick: () => void;
  onViewItemsClick?: (id: number) => void;
  
}

interface ModalDataItem {
  name: string;
  profile: string;
  count: number;
}

const CardComponent: React.FC<CardComponentProps> = ({
  id,
  content,
  FolderImage,
  myconnect_master_id,
  documentName,
  document_name,
  image_name,
  count,
  title,
  createdDate,
  onEditClick,
  isEditing,
  onImageChange,
  onUpdateClick,
  update = false,
  onTitleChange,
  isFolder = false,
  onViewItemsClick,
  onDeleteClick,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState<ModalDataItem[] | null>(null);
  const [isPdfModalOpen, setIsPdfModalOpen] = useState(false); 
  const [pdfUrl, setPdfUrl] = useState<string>("");
  const [searchQuery, setSearchQuery] = useState("");

  const openPdfModal = (pdfFile: string) => {
    if (pdfFile.endsWith(".pdf")) {
      setPdfUrl(pdfFile);
      setIsPdfModalOpen(true);
    } else {
      console.error("Not a valid PDF file");
    }
  };

  const closePdfModal = () => {
    setIsPdfModalOpen(false);
    setPdfUrl("");
  };

  const fetchData = async () => {
    const payload = { id: id };

    try {
      const response = await postDetails(APIList.VIEW_COUNT, payload);
      setModalData(response.data); 
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleViewCountClick = async () => {
    await fetchData();
    setShowModal(true); // Open the modal after fetching data
  };

  const handleCloseModal = () => {
    setShowModal(false); 
  };

  return (
    <>
      {/* <div className="card-header">
     <InputGroup style={{ width: "340px" }} className="mb-3 float-end">
        <Form.Control
          type="text"
          placeholder="Search..."
          value={searchQuery}
          onChange={() => alert("")}
        />
      </InputGroup>
      </div> */}
  
    <div className="cards bg-light">
      
    {/* <div className="profile-logo">
        {document_name ? (
            
            document_name.endsWith('.pdf') ? (
                
              <img 
              src={pdfforCards} 
              className="card-imagess" 
              alt="PDF Thumbnail" 
              onClick={() => openPdfModal(document_name)} 
          />
          
       
            ) : document_name.endsWith('.mp4') || document_name.endsWith('.mov') || document_name.endsWith('.avi') ? (
                
                <video className="card-image" controls>
                    <source src={document_name} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            ) : (
                
                <img src={document_name} className="card-image"  />
            )
        ) : (
            
            <img src={FolderImage} className="card-image"  />
        )}

       
        {isEditing && <input type="file" onChange={onImageChange} />}
    </div> */}

<div className="profile-logo">
    {document_name ? (
        document_name.endsWith('.pdf') ? (
            <div style={{ textAlign: 'center' }}>
                <img 
                    src={pdfforCards} 
                    className="card-imagess" 
                    alt="PDF Thumbnail" 
                    onClick={() => openPdfModal(document_name)} 
                />
                <button 
                    className="view-pdf-link" 
                    onClick={() => openPdfModal(document_name)}
                >
                    View PDF
                </button>
            </div>
        ) : document_name.endsWith('.mp4') || document_name.endsWith('.mov') || document_name.endsWith('.avi') ? (
            <video className="card-image" controls>
                <source src={document_name} type="video/mp4" />
                Your browser does not support the video tag.
            </video>
        ) : (
            <img src={document_name} className="card-image" />
        )
    ) : (
        <img src={FolderImage} className="card-image" />
    )}
    
    {isEditing && <input type="file" onChange={onImageChange} />}
</div>



        <div className="card-content">
          {update && isEditing ? (
            <input
              type="text"
              value={title}
              onChange={(e) => onTitleChange?.(e.target.value)}
              className="form-control mb-2"
            />
          ) : (
            <div className="card-nam">
              <p title={title} className="card-title">
                {title}
              </p>
            </div>
          )}
          <div className="card-nam">
            <p title={content} className="content-title">
              {content}
            </p>
          </div>

        
          {!isFolder && (
            <p className="created-date">
              View Count:{" "}
              <span
                onClick={handleViewCountClick}
                style={{
                  cursor: "pointer",
                  color: "blue",
                  textDecoration: "underline",
                }}
              >
                {count}
              </span>
            </p>
          )}

          <p className="created-date">{myconnect_master_id}</p>
          <p className="created-date">
            {formatDate(createdDate, 'dd-mm-yyyy')}
          </p>
          <button className="view-items-btn" onClick={onDeleteClick}>
            Delete
          </button>
          {isFolder && (
            <button
              className="view-items-btn mt-1"
              onClick={() => onViewItemsClick?.(id!)}
            >
              View Items
            </button>
          )}
          {isEditing && (
            <button className="upload-btn mt-2" onClick={onUpdateClick}>
              Update
            </button>
          )}
        </div>
      </div>

 <Modal
  show={showModal}
  onHide={handleCloseModal}
  size="lg"
  scrollable
  className="view-count-modal"
>
  <Modal.Header closeButton>
    <Modal.Title>View Count</Modal.Title>
  </Modal.Header>
  <Modal.Body style={{
              height: "300px",
              overflowY: "auto",
            }}className="modal-body-scrollable">
  {modalData && modalData.length > 0 ? (
    modalData.map((item, index) => (
      <div key={index} className="modal-item">
        <div className="modal-item d-flex align-items-center">
          <img
            src={item.profile || profileIcon}  
            // alt="Profile"
            className="modal-image me-3"
            style={{ width: "50px", height: "50px", borderRadius: "50%" }}
          />
          <h5>{item.name}</h5>
        </div>
        <p>Count: {item.count}</p>
      </div>
    ))
  ) : (
    <p>No data available</p>
  )}
</Modal.Body>

  <Modal.Footer>
    <Button variant="danger" onClick={handleCloseModal}>
      Close
    </Button>
  </Modal.Footer>
</Modal>


{isPdfModalOpen && (
  <div className="pdf-modal">
    <div className="pdf-modal-content">
      {/* Close button */}
      <button className="pdf-modal-close" onClick={closePdfModal}>
        &times;
      </button>
      <iframe src={pdfUrl} width="100%" height="500px" title="PDF Viewer" />
    </div>
  </div>
)}




    </>
  );
};

export default CardComponent;
